'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'rv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = ['M32 64l0 266.4 47.6 59.5c15.9-22.9 42.4-37.9 72.4-37.9 40.1 0 74 26.9 84.6 63.6l115.4 0 0-287.6 192 0 0-64-192 0 0-31.9c-42.7 0-85.3 0-128-.1l0 32-192 0zM96 168c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-112 0c-22.1 0-40-17.9-40-40l0-48zM384 320l0 52.1c15.2-12.6 34.7-20.1 56-20.1 40.1 0 74 26.9 84.6 63.6l19.4 0 0-95.6-160 0z', 'M208 0l-16 0 0 32-192 0 0 309.6 3.5 4.4 62 77.5c-1 5.3-1.5 10.8-1.5 16.5 0 48.6 39.4 88 88 88 45.9 0 83.6-35.1 87.6-80l112.7 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l48.4 0 0-148.8-2.7-4-64-96-4.7-7.1-120.6 0 0-32 192 0 0-128-192 0 0-32-176 0zM487.4 224l42.7 64-146.1 0 0-64 103.4 0zM384 372.1l0-52.1 160 0 0 96-19.3 0c-10.4-36.9-44.4-64-84.7-64-21.3 0-40.8 7.5-56 20.1zM352 416l-115.3 0c-10.4-36.9-44.4-64-84.7-64-30 0-56.5 15-72.4 37.9l-47.6-59.5 0-266.4 192 0 0-32 128 0 0 32 192 0 0 64-192 0 0 288zM152 384a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm288 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM136 128c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-112 0zm-8 40c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-112 0c-4.4 0-8-3.6-8-8l0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;